/*
* @Author: 王春岩 <Bolt>
* @Date:   2017-01-04 14:48:42
* @Last Modified by:   Bolt
* @Last Modified time: 2017-01-04 15:36:14
*/

'use strict';

import axios from 'axios';

function $shopBrands(data) {
    return axios({
        url: '/json/shopBrands.json',
        method: 'get',
        params: data
    });
}

function shopBrands() {
    return $shopBrands({
        type: 1,
        siteId: window._qiwa.__site_basic.siteId
    }).then(function (response) {
        return response.data;
    }).then(function (data) {
        return data.items;
    });
}

function $ShopSeriesByBrand (data) {
    return axios({
        url: '/json/ShopSeriesByBrand.json',
        method: 'get',
        params: data
    });
}

function ShopSeriesByBrand (brandCode) {
    return $ShopSeriesByBrand({
        type: 1,
        brandCode: brandCode,
        siteId: window._qiwa.__site_basic.siteId
    }).then(function (response) {
        return response.data;
    }).then(function (data) {
        return data.items;
    });
}

export {
    shopBrands,
    ShopSeriesByBrand
};



// WEBPACK FOOTER //
// ./src/api/defaultApi.js